import * as lunr from 'lunr';

/**
 * Lunr does stemming by default on all fields. Problem is we add '*' wildcard to all
 * searches and docs state 'when a search term contains a wildcard, no stemming is performed on the search term.'
 * This is an issue beacuse 'Rochester' does not return 'Rochester' while 'Roch', 'Rochest', etc does.
 * (Having 'er' does not work) The following resolves that problem.
 * https://lunrjs.com/guides/customising.html
 * @param builder 
 */
export default function replaceStemerWithOneThatKeepsOriginalAndStems(builder: lunr.Builder):void {
        const originalStemmer = lunr.stemmer;
        const newStemmer = (token: lunr.Token) => {
                const original = token.clone();
                const stemmed = originalStemmer(token);

                //console.log('tokens now', [original.toString(), stemmed.toString()]);

                if (original.toString() !== stemmed.toString()) {
                        // Only need both if stemmed version is different
                        return [original, stemmed];
                }
                return stemmed;
        };
        
        // Add ours
        builder.pipeline.before(lunr.stemmer, newStemmer);
        builder.searchPipeline.before(lunr.stemmer, newStemmer);
        // Remove built in stemmer
        builder.pipeline.remove(lunr.stemmer);
        builder.searchPipeline.remove(lunr.stemmer);
};
